import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Componentes
import ProtectedRoute from 'components/ProtectedRoute';

import NoFound from 'views/NoFound';
import Login from 'views/Login';

// Componentes privados
import Corporative from 'views/Corporation';
import UsersByCorps from 'views/UsersByCorps';

import Account from 'views/Account';

import UsersMetimur from 'views/UsersMetimur';
import RolesList from 'views/RolesList';
import ControlRate from 'views/ControlRate';
import NotificationDashboard from 'views/NotificationDashboard';
import Reports from 'views/Reports';
import Invoice from 'views/Invoice';
import Help from 'views/Help';
import Dashboard from 'views/Dashboard';
import UsersList from 'views/UsersList';
import FormUserEditable from 'views/FormUserEditable';
import FormUserEditableAdmin from 'views/FormUserEditableAdmin';
import FormRoleEditable from 'views/FormRoleEditable';
import Meter from 'views/Meters';
import Groups from 'views/Groups';
import Charge from 'views/Charge';

import MeterDashboard from 'views/Meter Dashboard';
import GroupDashboard from 'views/Group Dashboard';
import ChargeDashboard from 'views/Charge Dashboard';
import UpdateMeter from 'views/UpdateMeter';
import NewMeter from 'views/NewMeter';
import NewGroup from 'views/NewGroup';
import NewCorporation from 'views/NewCorporation';
import UpdateCorporation from 'views/UpdateCorporation';
import UpdateGroup from 'views/UpdateGroup';
import UpdateCharge from 'views/UpdateCharge';
import NewCharge from 'views/NewCharge';
import HardwareConfiguration from 'views/HardwareConfiguration';
import Concentrator from 'views/Concentrator';
import UpdateConcentrator from 'views/UpdateConcentrator';
import NewConcentrator from 'views/NewConcentrator';
import Card from 'views/Card';
import NewCard from 'views/NewCard';
import UpdateCard from 'views/UpdateCard';
import AllCards from 'views/AllCards';
import ControlCards from 'views/ControlCards';
import NewControlCard from 'views/NewControlCard';
import UpdateControlCard from 'views/UpdateControlCard/Index';
import { AllCardsHomeworks } from 'views/AllCardsHomeworks';
import { Homeworks } from 'views/Homeworks';
import NewHomeworks from 'views/NewHomeworks';
import { PowerFactor } from 'views/PowerFactor';
import NewPowerFactor from 'views/NewPowerFactor';
import { Voltage } from 'views/Voltage';
import NewVoltage from 'views/NewVoltage';
import ChargeInvoiceData from 'views/ChargeInvoiceData';
import AlertDashboard from 'views/AlertDashboard/Index';
import AlertSettings from 'views/AlertSettings';
import NewAlert from 'views/NewAlert';
import RecoveryPasswordEmail from 'views/Recovery From Password';
import RecoveredEmail from 'views/Recover Password Email';
import ChargeDashboardSolar from 'views/Charge Dashboard Solar';
import FormUser from 'views/FormUser';
import ChargeDashboardTrend from 'views/Charge Dashboard Trend';
import FormUserMetimur from 'views/FromUserMetimur';

export default function AppRoutes() {
  const user = useSelector((state) => state.user.user);

  return (
    <BrowserRouter history={history}>
      <Routes>
        {/* Redirección principal según `home_url` del usuario */}
        <Route
          path="/"
          element={<Navigate to={user.home_url || '/login'} replace={true} />}
        />
        {/* Rutas públicas */}
        <Route path="/login" index element={<Login />} />
        <Route path="/recoveredForm/:token" element={<RecoveredEmail />} />
        <Route path="/recoveredEmail" element={<RecoveryPasswordEmail />} />

        {/* Rutas privadas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/home" element={<Corporative />} />
          <Route path="/account" element={<Account />} />
          <Route path="/usersByCorps" element={<UsersByCorps />} />
          <Route path="/usersMetimur" element={<UsersMetimur />} />
          <Route path="/roles" element={<RolesList />} />
          <Route path="/controlRate" element={<ControlRate />} />
          <Route
            path="/notificationDashboard"
            element={<NotificationDashboard />}
          />
          <Route path="/reports" element={<Reports />} />
          <Route path="/invoices" element={<Invoice />} />
          <Route path="/help" element={<Help />} />
          <Route path="/dashboard/:corpId" element={<Dashboard />} />
          <Route path="/users/:corpId" element={<UsersList />} />
          <Route path="/updateUser/:userId" element={<FormUserEditable />} />
          <Route
            path="/updateAdminUser/:userId"
            element={<FormUserEditableAdmin />}
          />
          <Route path="/newMetimurUser" element={<FormUserMetimur />} />
          <Route path="/newUser/:corpId" element={<FormUser />} />
          <Route path="/updateRole/:roleId" element={<FormRoleEditable />} />
          <Route path="/corporative/:corpId" element={<Meter />} />
          <Route path="/meter/:meterId" element={<Groups />} />
          <Route path="/group/:groupId" element={<Charge />} />
          <Route
            path="/meterDashboard/:corpId/:meterId"
            element={<MeterDashboard />}
          />
          <Route path="/groupDashboard/:groupId" element={<GroupDashboard />} />
          <Route
            path="/chargeDashboard/group/:groupId/charge/:chargeId"
            element={<ChargeDashboard />}
          />
          <Route
            path="/chargeDashboard/group/:groupId/charge/:chargeId/trend"
            element={<ChargeDashboardTrend />}
          />

          <Route
            path="/dashboardSolarCharge/group/:groupId/charge/:chargeId"
            element={<ChargeDashboardSolar />}
          />
          <Route path="/newCorporation" element={<NewCorporation />} />
          <Route
            path="/updateCorporative/:corpId"
            element={<UpdateCorporation />}
          />

          <Route path="/newMeter/:meterId" element={<NewMeter />} />
          <Route path="/updateMeter/:meterId" element={<UpdateMeter />} />

          <Route path="/newGroup/:corpId/:meterId" element={<NewGroup />} />
          <Route path="/updateGroup/:groupId" element={<UpdateGroup />} />

          <Route path="/newCharge/:meterId/:groupId" element={<NewCharge />} />
          <Route path="/updateCharge/:chargeId" element={<UpdateCharge />} />

          <Route
            path="/hardwareConfiguration/:meterId"
            element={<HardwareConfiguration />}
          />
          <Route path="/concentradors/:meterId" element={<Concentrator />} />
          <Route
            path="/newConcentrator/:meterId"
            element={<NewConcentrator />}
          />
          <Route
            path="/updateConcentrator/:meterId"
            element={<UpdateConcentrator />}
          />
          <Route path="/card/:meterId" element={<Card />} />
          <Route
            path="/newCard/:meterId/:concentratorId"
            element={<NewCard />}
          />
          <Route path="/updateCard/:meterId/:cardId" element={<UpdateCard />} />
          <Route path="/allcards/:meterId" element={<AllCards />} />
          <Route path="/controlCards/:cardId" element={<ControlCards />} />
          <Route
            path="/newControlCard/:concentratorId/:cardId"
            element={<NewControlCard />}
          />
          <Route
            path="/updateControlCard/:cardControlId"
            element={<UpdateControlCard />}
          />

          <Route
            path="/allcardsHomework/:meterId"
            element={<AllCardsHomeworks />}
          />
          <Route path="/homeworks/:cardId" element={<Homeworks />} />
          <Route
            path="/newHomework/:concentratorId/:cardId"
            element={<NewHomeworks />}
          />

          <Route path="/powerfactor/:meterId" element={<PowerFactor />} />
          <Route path="/newPowerFactor/:meterId" element={<NewPowerFactor />} />
          <Route
            path="/editPowerFactor/:meterId/:fpId"
            element={<NewPowerFactor />}
          />

          <Route path="/voltage/:meterId" element={<Voltage />} />
          <Route path="/newVoltage/:meterId" element={<NewVoltage />} />
          {/* <Route path="/updateVoltage/:voltageId" element={<UpdateVoltage />} /> */}

          <Route
            path="/invoiceDataCharge/:chargeId"
            element={<ChargeInvoiceData />}
          />

          <Route
            path="/group/:groupId/charge/:chargeId/alert"
            element={<AlertDashboard />}
          />

          <Route
            path="/alerts/:groupId/charge/:chargeId"
            element={<AlertSettings />}
          />

          <Route
            path="/newUserAlert/:groupId/charge/:chargeId"
            element={<NewAlert />}
          />

          <Route path="/editUserAlet/:alertId" element={<NewAlert />} />
        </Route>

        {/* Ruta para no encontrados */}
        <Route path="*" element={<NoFound />} />
      </Routes>
    </BrowserRouter>
  );
}
